import Logger from '../Logger/Logger';

export default class DateUtility {
    private logger = new Logger();

    public formatUnixTimestampToDateString(
        timestamp: number,
        throwException: boolean = true,
    ): string {
        try {
            if (!Number.isInteger(timestamp)) {
                if (throwException) {
                    throw new Error(
                        `ERROR in DateUtils.formatUnixTimestampToDateString(). Provided timestamp (${timestamp}) is not a valid integer.`,
                    );
                }
                return '';
            }

            const date = new Date(timestamp * 1000);
            const options: Intl.DateTimeFormatOptions = {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
                timeZone: 'Asia/Kolkata',
            };

            const formattedDate = date.toLocaleString('en-GB', options);

            return formattedDate;
        } catch (e) {
            this.logger.error(e);
            if (throwException) throw e;
            return '';
        }
    }
}
